import React, { useReducer } from "react";
import { getLocationService } from "src/core/services/location.service";
import LocationContext from "../context/LocationContext";
import LocationReducer from "../reducer/LocationReducer";
import {
  GET_ALL_LOCATIONS,
  SET_LOCATION_LOADING,
} from "../types/locations.type";

const initialLocation = {
  locations: [],
  location: null,
  loading: false,
  error: null,
  total: 0,
};

export const LocationProvider = ({ children }) => {
  const [location, locationDispatch] = useReducer(
    LocationReducer,
    initialLocation
  );
  const loading = (isLoading: boolean) => ({
    type: SET_LOCATION_LOADING,
    isLoading,
  });

  // function to get Locations
  const getLocations = async () => {
    locationDispatch(loading(true));
    const locations = await getLocationService();
    // console.log(locations);

    locationDispatch({ type: GET_ALL_LOCATIONS, payload: locations });
    locationDispatch(loading(false));
    return locations;
  };

  return (
    <LocationContext.Provider value={{ location, locationDispatch, getLocations }}>
      {children}
    </LocationContext.Provider>
  );
};
